/* eslint-disable react/no-danger */
import React from 'react';
import CompanyInfo from './info';
import Editable from './editable';
import Locations from './locations';
import ZSpinner from '../../z-spinner';
import OryxButton from '../oryx-shared/oryx-button/type-button';
import ZModal from '../../z-modal';
import styles from './company.module.scss';
import FetchStatus from '../utils/fetch-status';
import { Error } from './utils';
import { formatDate, statusLabelMap, getEffectivePublished } from '../utils/companies';

const CompanyView = ({
  fetchStatus,
  company,
  infoModalState,
  showModal,
  openModal,
  onClickSave,
  primaryLocations = [],
  secondaryLocations = [],
  countryName,
}) => {
  const partnerSince = company?.onboardedOn;
  const published = getEffectivePublished(company);
  const status = company?.status;
  const statusLabel = status ? statusLabelMap[status] || status : undefined;
  const websites = company?.website ? [company.website] : [];

  return (
    <>
      <div className={styles.company}>
        {fetchStatus === FetchStatus.FETCHING && (
          <div className={styles.spinner}>
            <ZSpinner />
          </div>
        )}
        {fetchStatus === FetchStatus.ERROR && (
          <div className={styles.spinner}>
            <Error>
              There was an error or this company doesn&apos;t exist.
            </Error>
          </div>
        )}
        {company && (
          <div className={styles['company-wrapper']}>
            <div>
              <p className={styles['company-wrapper__created']}>
                {`Partner Since: ${formatDate(partnerSince)}`}
              </p>
              <div className={styles['company-wrapper__title']}>
                <h1>
                  {`Profile Status: ${published ? 'Published' : 'Unpublished'}`}
                </h1>
              </div>
            </div>
      <CompanyInfo
        name={company.name}
        id={company.id}
        country={countryName}
        websites={websites}
        statusLabel={statusLabel}
      />
            <Editable
              errors={{}}
              id={company.id}
            />
            <Locations
              primaryLocations={primaryLocations}
              secondaryLocations={secondaryLocations}
            />
            <div className={styles['company-wrapper__submit']}>
              <OryxButton
                style={{
                  width: 'fit-content',
                  padding: '10px 20px',
                  height: '35px',
                  margin: '13px 0 20px',
                }}
                onClick={onClickSave}
              >
                Save
              </OryxButton>
            </div>
          </div>
        )}
      </div>
      <ZModal
        maxHeight="90%"
        open={showModal}
        toggleModal={openModal}
        useOverlay
      >
        <div className={styles['save-modal-wrapper']}>
          { !infoModalState.error &&
            <h2>Changes Were Saved</h2>
          }
          { infoModalState.error &&
            <h2>{infoModalState.error}</h2>
          }
          { infoModalState.published &&
            <h3>Page is published</h3>
          }
          { !infoModalState.published &&
            <h3>However all conditions must be met in order to publish</h3>
          }
          <ul>
          { !infoModalState.firstName &&
            <li>First Name must not be blank</li>
          }
          { !infoModalState.statusEligible &&
            <>
              <li>Status must not be <u>New</u></li>
              <li>Status must not be <u>Onboarding</u></li>
              <li>Status must not be <u>Inactive</u></li>
            </>
          }
          </ul>
        </div>
        <div className={styles.modal__confirm}>
          <OryxButton
            style={{
              width: 'fit-content',
              padding: '10px 20px',
              height: '35px',
              margin: '13px 0 20px',
            }}
            onClick={openModal}
          >
            Ok
          </OryxButton>
        </div>
      </ZModal>
    </>
  );
};

export default CompanyView;
